import React from "react";
import { cn } from "@/lib/utils";
import { CatalogDirectoryCategory } from "../../api/fetchProductCatalogDirectory";

interface CategoryFilterProps {
  categories: CatalogDirectoryCategory[];
  countsByCategoryId: Record<string, number>;
  totalCount: number;
  selectedCategoryId: string | null;
  onSelect: (categoryId: string | null) => void;
}

const chipBaseClass =
  "flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm transition-colors border";
const chipInactiveClass =
  "border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:border-gray-300 dark:hover:border-slate-600";
const chipActiveClass =
  "border-transparent bg-gray-900 text-white dark:bg-white dark:text-gray-900";

export default function CategoryFilter({
  categories,
  countsByCategoryId,
  totalCount,
  selectedCategoryId,
  onSelect,
}: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        className={cn(
          chipBaseClass,
          selectedCategoryId === null ? chipActiveClass : chipInactiveClass,
        )}
        onClick={() => onSelect(null)}
        type="button"
      >
        All Products
        <span className="text-xs opacity-70">{totalCount}</span>
      </button>
      {categories.map((category) => (
        <button
          className={cn(
            chipBaseClass,
            selectedCategoryId === category.id
              ? chipActiveClass
              : chipInactiveClass,
          )}
          key={category.id}
          onClick={() => onSelect(category.id)}
          type="button"
        >
          {category.name}
          <span className="text-xs opacity-70">
            {countsByCategoryId[category.id] ?? 0}
          </span>
        </button>
      ))}
    </div>
  );
}
